import { rootApi } from "../../api/rootApi";

export const schemeApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchSchemeWalletOfAppUserBySchemeId: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/scheme-wallet?scheme_id=${params.scheme_id}&app_user_id=${params.app_user_id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    calculateTDSOfScheme: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/scheme-wallet/calc-tds?scheme_id=${params.scheme_id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    fetchAllUserWallets: builder.mutation({
      query: ({ body, token, slug }) => {
        return {
            method: "POST",
            url: `/tenant/scheme/all-scheme-wallets`,
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
                slug: slug,
            },
            body: body,
        };
      },
    }),
    fetchSchemeWalletsBySchemeId: builder.mutation({
      query: ({ schemeId, token, slug, mobile, user_id, page, limit }) => ({
        method: "GET",
        url: `/tenant/scheme/wallets/${schemeId}?mobile=${mobile || ""}&user_id=${user_id || ""}&page=${page || 1}&limit=${limit || 10}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          slug: slug,
        },
      }),
    }),
    updateSchemeWalletStatus: builder.mutation({
      query: ({ body, token, slug }) => {
        return {
            method: "POST",
            url: `/tenant/scheme-wallet/status`,
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
                slug: slug,
            },
            body: body,
        };
      },
    }),
  }),
});

export const {
    useFetchSchemeWalletOfAppUserBySchemeIdMutation,
    useCalculateTDSOfSchemeMutation,
    useFetchAllUserWalletsMutation,
    useFetchSchemeWalletsBySchemeIdMutation,
    useUpdateSchemeWalletStatusMutation,
} = schemeApi;
